import { LoadableAfterPaint, type LoadableType } from '@confluence/loadable';

import type { AgentContextPageProps } from '../src/pages/agent-context/AgentContextPage.tsx';

export const AgentContextPageLoader: LoadableType<AgentContextPageProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgentContextPage" */ '../src/pages/agent-context/AgentContextPage.tsx'
			)
		).AgentContextPage,
});
